import { gql } from '@apollo/client'

const contentFiledsFragment = `
  promotionalBanner
  altLogoImage
  logoImage
  splashImage
  shop {
    header {
      bannerImage
    }
  }
`

const QUERY_GET_CONTENT_BY_SLUG = gql`
  query getContent($merchantSlug: String!) {
    getContent(merchantSlug: $merchantSlug) {
      ${contentFiledsFragment}
    }
  }
`

export { QUERY_GET_CONTENT_BY_SLUG }
